const state = {
  reportUpCheckData: {
    ddIsValid: false,
    dsInvalidLevel: '',
    dsInvalidStatus: '',
  },
  invalidCustom:[],
  dsStatusCustom:[],
  reportUpCheckObj:{},
}

const getters = {
  reportUpCheckData: state => {
    return state.reportUpCheckData
  },
  invalidCustom:state=>{
    return state.invalidCustom
  },
  dsStatusCustom:state => {
    return state.dsStatusCustom
  },
  reportUpCheckObj:state => {
    return state.reportUpCheckObj
  }
}

const mutations = {
  setReportUpCheckData(state, data) {
    state.reportUpCheckObj = data
  },
  setInvalidCustom(state,data){
    state.invalidCustom = data
  },
  setDsStatusCustom(state,data){
    state.dsStatusCustom = data
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}




// WEBPACK FOOTER //
// ./src/store/model/plugin.js